import { render, staticRenderFns } from "./A4ASubtestTable.vue?vue&type=template&id=23e8d1ea&scoped=true"
import script from "./A4ASubtestTable.vue?vue&type=script&lang=js"
export * from "./A4ASubtestTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e8d1ea",
  null
  
)

export default component.exports